import { IS_NZ_STORE, PRIVATE_BUSINESS_NAME_LABEL } from '../constants'

export const buildSearchNoResults = () => {
  return `<li class="no-results text-large foreground-color-pine-green padding-left-2x padding-right-2x">No Results...</li>`
}

export const buildSearchResultListItems = (container, listOfBusinesses) => {
  container.innerHTML = `<ul class="padding-top-2x padding-bottom-2x">${listOfBusinesses}</ul>`
}

export const buildSmallBusinessNumberElement = (
  businessNumberLabel,
  businessNumber
) => {
  return `<small class="text-medium foreground-dark-green margin-left-1x">${businessNumberLabel}: ${businessNumber}</small>`
}

export const buildBusinessListItem = (businessName, businessNumber, isLegalName=true) => {
  let businessNumberHTML = ``
  const businessNumberLabel = IS_NZ_STORE ? `NZBN` : `ABN`
  const isPrivateBusinessName = businessName === PRIVATE_BUSINESS_NAME_LABEL
  if (businessNumber) {
    businessNumberHTML = buildSmallBusinessNumberElement(
      businessNumberLabel,
      businessNumber
    )
  }
  if (isPrivateBusinessName) {
    /**
     *
     * Client request - #SSSR-257: NZ Only. If the business legal name (entity) equals a private business,
     * set the 'name="legal_name"' input value to '' (blank)
     * set a new field 'name="private_legal_name"' to state the business name is private
     * JS: using dataset.privateLegalName & dataset.businessNumber
     */
    const dataAtts = `data-private-legal-name="${PRIVATE_BUSINESS_NAME_LABEL}" data-business-number="${businessNumber}"`
    return `<li class="text-large foreground-color-pine-green padding-left-2x padding-right-2x item-clickable" data-is-legal-name="${isLegalName}" ${dataAtts}>${businessName} ${businessNumberHTML}</li>`
  }
  const dataAtts = `data-legal-name="${businessName}" data-trading-name="${businessName}" data-business-number="${businessNumber}"`
  return `<li class="text-large foreground-color-pine-green padding-left-2x padding-right-2x item-clickable" data-is-legal-name="${isLegalName}" ${dataAtts}>${businessName} ${businessNumberHTML}</li>`
}
